var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$tc("request_stars.request_a_star", 1)))]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        !_vm.$userIsClient
          ? _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "panel panel-send-request" }, [
                _c("div", { staticClass: "panel-body" }, [
                  _vm.$requestFormConfig.show_requester_heading
                    ? _c("div", [
                        _c("h3", [_vm._v("Requested By")]),
                        _vm._v(" "),
                        _c("hr"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12" }, [
                      _c(
                        "div",
                        { staticClass: "radio radio-primary col-xs-4" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.existingClient,
                                expression: "existingClient",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              name: "existing_client",
                              id: "existing_client_id",
                            },
                            domProps: {
                              value: true,
                              checked: _vm._q(_vm.existingClient, true),
                            },
                            on: {
                              change: function ($event) {
                                _vm.existingClient = true
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "existing_client_id" } },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$tc("request_stars.existing_client", 1)
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.booking.is_offer
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.existingClient,
                                  expression: "existingClient",
                                },
                              ],
                              class: [
                                "form-group col-xs-8",
                                _vm.hasErrorClass(_vm.$v.selectedClient),
                              ],
                            },
                            [
                              _c("selectize", {
                                ref: "clients",
                                staticClass: "selectize selectize-single",
                                attrs: {
                                  name: "clients",
                                  "key-context": "clients",
                                  placeholder: _vm.$tc(
                                    "request_stars.existing_client",
                                    2
                                  ),
                                  autocomplete: "off",
                                  "fetch-results": _vm.handleGetClientsCallback,
                                  "fetch-more-results":
                                    _vm.handleGetNextClientsCallback,
                                  options: _vm.clientOptions,
                                },
                                model: {
                                  value: _vm.$v.selectedClient.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.selectedClient,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.selectedClient.$model",
                                },
                              }),
                              _vm._v(" "),
                              _c("vuelidate-help", {
                                attrs: {
                                  field: _vm.$v.selectedClient,
                                  label: _vm.$tc(
                                    "request_stars.existing_client",
                                    1
                                  ),
                                },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.existingClient,
                                  expression: "existingClient",
                                },
                              ],
                              class: [
                                "form-group col-xs-8",
                                _vm.hasErrorClass(_vm.$v.selectedClient),
                              ],
                            },
                            [
                              _c("selectize", {
                                ref: "clients",
                                staticClass: "selectize selectize-single",
                                attrs: {
                                  name: "clients",
                                  "key-context": "clients",
                                  placeholder: _vm.Admins,
                                  autocomplete: "off",
                                  "fetch-results": _vm.handleGetAdminsCallback,
                                  "fetch-more-results":
                                    _vm.handleGetNextAdminsCallback,
                                  options: _vm.clientOptions,
                                },
                                model: {
                                  value: _vm.$v.selectedClient.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.selectedClient,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.selectedClient.$model",
                                },
                              }),
                              _vm._v(" "),
                              _c("vuelidate-help", {
                                attrs: {
                                  field: _vm.$v.selectedClient,
                                  label: "Existing Admins",
                                },
                              }),
                            ],
                            1
                          ),
                    ]),
                    _vm._v(" "),
                    _vm.$requestFormConfig.allow_create_client &&
                    !_vm.booking.is_offer
                      ? _c("div", { staticClass: "col-xs-12" }, [
                          _c("div", { staticClass: "radio radio-primary" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.existingClient,
                                  expression: "existingClient",
                                },
                              ],
                              attrs: {
                                type: "radio",
                                name: "profile_visibility",
                                id: "profile_visibility_hidden",
                              },
                              domProps: {
                                value: false,
                                checked: _vm._q(_vm.existingClient, false),
                              },
                              on: {
                                change: function ($event) {
                                  _vm.existingClient = false
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "profile_visibility_hidden" } },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$tc("request_stars.new_client", 1)
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.existingClient,
                                  expression: "!existingClient",
                                },
                              ],
                              staticClass:
                                "form-horizontal panel-body panel panel-grey",
                            },
                            [
                              _c("create-user", { ref: "createUser" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-md-12 col-lg-6" },
                                  [
                                    _c("field-input", {
                                      attrs: {
                                        model: _vm.$v.newClient.company,
                                        "field-name": _vm._f("sentenceCase")(
                                          _vm.$t("organisation")
                                        ),
                                        "show-required":
                                          _vm.showClientDepartmentFields,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-12 col-lg-6" },
                                  [
                                    _c("field-input", {
                                      attrs: {
                                        model: _vm.$v.newClient.position,
                                        "field-name": "Job Title",
                                        "show-required":
                                          _vm.showClientDepartmentFields,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.$showDepartmentField
                                ? _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-12 col-lg-6" },
                                      [
                                        _c("department-selection", {
                                          attrs: {
                                            model:
                                              _vm.$v.newClient.department_id,
                                          },
                                          on: {
                                            input: _vm.handleDepartmentSelected,
                                            added: _vm.handleDepartmentAdded,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$activeClientModuleEnabled
                                ? _c("div", { staticClass: "row spacer-t-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-12 col-lg-6" },
                                      [
                                        _c("field-input", {
                                          attrs: {
                                            model: _vm.$v.newClient.password,
                                            "field-name": "Password",
                                            type: "password",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-12 col-lg-6" },
                                      [
                                        _c("field-input", {
                                          attrs: {
                                            model:
                                              _vm.$v.newClient
                                                .password_confirmation,
                                            "field-name":
                                              "Password Confirmation",
                                            type: "password",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _c("booking-form", {
              ref: "form",
              attrs: {
                "property-mutator": _vm.setRequestProperty,
                booking: _vm.booking,
                validationTriggered: _vm.validationTriggered,
                "additional-departments": _vm.additionalDepartments,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dashboard-block" },
              [
                _vm.$userIsAdmin
                  ? _c(
                      "ladda-button",
                      {
                        ref: "publishbtn",
                        staticClass: "btn btn-primary",
                        attrs: {
                          click: () => {
                            return _vm.handleSubmitRequestCallback("request")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(!_vm.$vlastMode ? "Save" : "Publish") +
                            " " +
                            _vm._s(_vm.$t("Request")) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "ladda-button",
                  {
                    ref: "addanotherbtn",
                    staticClass: "btn btn-outline",
                    attrs: {
                      click: () => {
                        return _vm.handleSubmitRequestCallback(
                          _vm.$userIsAdmin ? "request" : "vetting",
                          true
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$vlastMode && _vm.$userIsAdmin
                            ? "Publish"
                            : _vm.$vlastMode && _vm.$userIsClient
                            ? "Submit"
                            : "Save"
                        ) +
                        " and add another\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ladda-button",
                  {
                    ref: "draftbtn",
                    staticClass: "btn btn-outline",
                    attrs: {
                      click: () => {
                        return _vm.handleSubmitRequestCallback("vetting")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$userIsAdmin
                            ? "Save As Pending"
                            : "Submit For Approval"
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }